
import { gridSize, gridSizeMdLg12, gridSizeMdLg4, newSolicitudesEgresoSchema, ROUTER_PATHS } from "@/shared"
import { useCreateSolicitudesEgresos, useFetchBodegas, useFetchUbicaciones, useUpdateSolicitudesEgresos } from "@/shared/actions/erp"
import { LoaderComponent, SampleDatePicker, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui"
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination"

import { Producto_solicitud} from "@/shared/interfaces/erp/compras/solicitudes-egreso.interface"
import { BODEGAS, TiposBodegaEnum, TipoUbicacionEnum, Ubicaciones } from "@/shared/interfaces/erp/inventario"
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store"
import { useUiStore } from "@/store/ui"
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Grid, Paper, TextField } from "@mui/material"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import ModalProductoEgresoComponete from "./ModalProductoEgresoComponente"
import { AlertSeverityEnum, MaterialTransferido } from "@/shared/interfaces"
import useTableColumnsSolicitudEgreso from "@/shared/hooks/useTableColumnsSolicitudEgreso"
import { useEffect, useRef } from "react"
// import CustomTextFielRead from "@/shared/components/ui/CustomTextFielRead"
import CustomTextFielReadEgreso from "./CustomTextFielReadEgreso"
import { toast } from "react-toastify"
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

///carga de excel
import { useUploadFile } from "@/shared/hooks/useUploadFile";
import { BucketAwtENUM } from "@/shared/constants";
import { cargarExcelSolicitudEgreso } from "@/shared/actions/erp/compras/solicitud-egreso.actions"

type saveSolicitudEgresoProps = {
  title: string,
  editData?: any
}
type SaveFormData = {
  codigo?: string;
  numero_referencia?: string;
  productos?: Producto_solicitud[]; // Aquí especificamos que `productos` es un arreglo de `Producto`
  estado_solicitud?: string;
  estado?: string;
  bodega: string;
  ubicacion: string;
  fecha_creacion?: string;
  //observaciones?: string;
  observaciones?: {
    observacionSolicitudPedido?: string;
    observacionRevisionSolicitudPedido?: string;
  }
};
export default function SaveSolicitudEgresoPage({ title, editData }: saveSolicitudEgresoProps) {
  //store
  const { columnsSolicitudEgreso } = useTableColumnsSolicitudEgreso()
  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  const handleCopiarLista = useCargarSeriesProductos(s=>s.handleCopiarLista)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const setAlert = useUiStore(s => s.setAlert)
  const navigate = useNavigate()

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newSolicitudesEgresoSchema),
  });

  const { handleSubmit,
    reset,
    formState: { errors }
  } = form;
  // Fetch
  const updateSolicitudEgreso = useUpdateSolicitudesEgresos({})

  const { data: dataBodegas, isLoading: isLoadingbodegas } =
    useFetchBodegas({
      page_size: 600,
      nombre: TiposBodegaEnum.BODEGA_MATRIZ_QUITO
    })

  const { data: ubOrigen, isLoading: isLoadingUbOrigen } = useFetchUbicaciones({
    page_size: 600,
    bodega: dataBodegas?.data?.data[0]?.codigo,
    nombre: TipoUbicacionEnum.GENERICA
  }, !!dataBodegas?.data?.data[0]?.codigo)
  //********** Para opciones
  /* const { data: ubOrigen, isLoading: isLoadingUbOrigen } = useFetchUbicaciones({
    page_size: 600,
    bodega: form.getValues().bodega,
    nombre: TipoUbicacionEnum.GENERICA
  }, !!form.watch('bodega')) */

  const createSolicitudEgreso = useCreateSolicitudesEgresos({
    returnUrl: ROUTER_PATHS.pedidos.solicitud_pedidos_nav
  })
  //**********************CARGA AUTOMATICA BODEGA Y UBICACION
  useEffect(() => {
    if (isLoadingbodegas || isLoadingUbOrigen) return;

    const bodega = dataBodegas?.data?.data[0]?.codigo
    const ubicacion = ubOrigen?.data?.data[0]?.codigo

    if (bodega && !form.getValues('bodega')) {
      form.setValue('bodega', bodega)
    }
    if (ubicacion && !form.getValues('ubicacion')) {
      form.setValue('ubicacion', ubicacion)
    }

  }, [dataBodegas, ubOrigen, form])

  const ref = useRef(false)
  useEffect(() => {
    if (ref.current) return;
    if (isLoadingUbOrigen || isLoadingbodegas) return;

    const { bodega, ubicacion } = form.getValues()

    ref.current = true

    if (!bodega || !ubicacion) {
      toast.error('La ubicación generica no existe en la bodega Matriz Quito.')
      navigate(ROUTER_PATHS.pedidos.solicitud_pedidos_nav);
      return;
    }

  }, [isLoadingUbOrigen, isLoadingbodegas])
  //edit
  useEffect(() => {
    if (!editData) return
    reset({...editData})
    if(editData.productos){
      const aux = editData.productos.map((item:any)=>({
        ...item,
        codigo: item.codigo?.toString(),
        cantidad: item.cantidad !== undefined ? item.cantidad?.toString() :'0'
      }))
      handleCopiarLista(aux)
    }
  }, [editData])
  //* onSave
  const onSave = async (e: SaveFormData) => {
    if (productos.length === 0)
      return setAlert(true, 'Seleccione al menos un producto.', AlertSeverityEnum.error)
    const solicitudEgreso = {
      ...e,
      productos: productos,
      observaciones: {
        observacionSolicitudPedido: form.getValues('observaciones.observacionSolicitudPedido'),

      }

    } as any

    const DEBUG_PAYLOAD = false;
    if (DEBUG_PAYLOAD) {
      console.log('payload solicitudEgreso:', solicitudEgreso)
      console.log('payload JSON:', JSON.stringify(solicitudEgreso, null, 2))
      return
    }

    if (editData) {
      const {user,...restData}=solicitudEgreso
      await updateSolicitudEgreso.mutateAsync({
        id:editData.id_solicitudegreso,
        data: {
          ...restData
        }
      })
      clearSelectedItems()
      return navigate(ROUTER_PATHS.pedidos.solicitud_pedidos_nav)
    }
    const respSolicitudEgreso = await createSolicitudEgreso.mutateAsync(solicitudEgreso)
    if (respSolicitudEgreso.code !== 200) return;
    clearSelectedItems()
    reset({})
    navigate(ROUTER_PATHS.pedidos.solicitud_pedidos_nav)
  }
  //archivo excel
  const { fileInputRef, handleUploadFile } = useUploadFile();
  const llenarTablaItems = async (event: React.ChangeEvent<HTMLInputElement>) => {
  const file = event.target.files?.[0];
  if (!file) return;

  const ubicacion = form.getValues("ubicacion");
  if (!ubicacion) {
    toast.warning("No hay una ubicación seleccionada para validar el stock.");
    return;
  }

  // Mensaje de "procesando" que se mantiene mientras sube y valida el backend
  const toastId = toast.loading("Procesando archivo...");
  try {
    // 1. Subir archivo a S3
    const respUpload = await handleUploadFile(file, BucketAwtENUM.DOCUMENTO_SOLICITUD_EGRESO);

    // 2. Enviar URL al backend para que parsee y valide (existencia + stock)
    const resp = await cargarExcelSolicitudEgreso({
      url: respUpload.url,
      ubicacion,
    });

    const productos = resp.data?.productos ?? [];
    const errores = resp.data?.errores ?? [];

    // 3. Llenar tabla con los productos validados (mismo flujo que handleAgregarProducto)
    productos.forEach((producto) => {
      handleAgregarProducto(producto);
    });

    // 4. Cerrar el "procesando" con un resumen del resultado
    if (productos.length > 0) {
      toast.update(toastId, {
        render: `${productos.length} producto(s) agregado(s) correctamente.`,
        type: "success",
        isLoading: false,
        autoClose: 4000,
      });
    } else {
      toast.update(toastId, {
        render: "No se agregó ningún producto. Revise las observaciones.",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });
    }

    // 5. Mostrar los detalles: productos que no existen o sin stock suficiente
    if (errores.length) {
      errores.forEach((err) => {
        toast.warning(err, { autoClose: 6000 });
      });
    }

  } catch (error) {
    toast.update(toastId, {
      render: "Error al procesar el archivo Excel.",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
  } finally {
    if (fileInputRef.current) fileInputRef.current.value = "";
  }
 }

  useEffect(() => {
    return () => {
      reset()
      clearSelectedItems()
    }
  }, [])

  if (isLoadingUbOrigen || isLoadingbodegas) return <LoaderComponent />
  return (
    <>
      <SingleTableBoxScene
        title={title}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.pedidos.solicitud_pedidos_nav}
        visibleReport={false}
        enableCreateOrEditBtn={true}
        //textCreateOrEditBtn="Crear Solicitud"
        textCreateOrEditBtn={editData? "Guardar Cambios":"Crear Solicitud"}
        fnCreateOrEdit={handleSubmit(onSave,
          () => { setAlert(true, 'Campos Obligatorios', AlertSeverityEnum.error) }
        )}
      >
      <Grid container sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 4,
      }}>

        <Button onClick={()=>(fileInputRef.current?.click())}
         startIcon={<CloudDownloadIcon />}
          sx={{
    display:'inline-flex',
    justifyContent: 'flex-end',
    position: 'relative',
    left: 0,
    overflow: 'hidden',
    px: 3,
    py: 1.2,
    borderRadius: '14px',

    background: 'linear-gradient(145deg, #6366f1, #4f46e5)',
    color: '#fff',

    boxShadow: `
      0 10px 25px rgba(99,102,241,.35),
      inset 1px 1px 2px rgba(255,255,255,.18),
      inset -2px -2px 6px rgba(0,0,0,.18)
    `,

    transition: 'all .3s ease',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-120px',
      width: '90px',
      height: '100%',
      background:
        'linear-gradient(120deg, transparent, rgba(255,255,255,.45), transparent)',
      transform: 'skewX(-25deg)',
      transition: '0.8s',
    },

    '&:hover::before': {
      left: '130%',
    },

    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: `
        0 16px 30px rgba(99,102,241,.45),
        inset 1px 1px 2px rgba(255,255,255,.22),
        inset -2px -2px 8px rgba(0,0,0,.22)
      `,
    },

    '&:active': {
      transform: 'scale(.97)',
    }}}>Carga masiva solicitud de pedido</Button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".xls,.xlsx"
        style={{ display: "none" }}
        onChange={(e) => {
          llenarTablaItems(e);
          e.target.value = "";  // limpiar para poder re-seleccionar el mismo archivo
        }}

      />
      </Grid>
        <>
          <Grid container spacing={3}>
            <SampleDatePicker
              label={"Fecha de la solicitud"}
              name="fecha_transferencia"
              control={form.control}
              defaultValue={new Date().toISOString().slice(0, 10)} // Set default value to today's date in ISO string format
              error={errors.fecha_creacion}
              helperText={errors.fecha_creacion?.message}
              size={gridSizeMdLg4}
              readonly={true}
              disabled={true}
            />
             {/* <CustomTextFielRead<BODEGAS> */}
            <CustomTextFielReadEgreso<BODEGAS>
              label="Bodega *"
              name="bodega"
              value={dataBodegas?.data.data[0]}
              valueKey={"nombre"}
              actualValueKey={"codigo"}
              defaultValue={form.getValues().bodega || ''}
              isLoadingData={isLoadingbodegas}
              control={form.control}
              //disabled={true}
              size={gridSizeMdLg4}
            />
            {/* <CustomTextFielRead<Ubicaciones> */}
            <CustomTextFielReadEgreso<Ubicaciones>
              label="Ubicación *"
              name="ubicacion"
              value={ubOrigen?.data.data[0]}
              valueKey={"nombre"}
              actualValueKey={"codigo"}
              defaultValue={form.getValues().ubicacion || ''}
              isLoadingData={isLoadingUbOrigen}
              control={form.control}
              //disabled={true}
              size={gridSizeMdLg4}
            />
            <Grid item {...gridSizeMdLg12}>
              <TextField
                {...form.register("observaciones.observacionSolicitudPedido")}
                variant="outlined"
                label="Observación"
                multiline
                rows={2}
                fullWidth
                error={!!errors.observaciones?.observacionSolicitudPedido}
                helperText={errors.observaciones?.observacionSolicitudPedido?.message}
              />
            </Grid>
            <Grid item {...gridSize}>
              <Paper className="paper-producto" sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.06)', transition: 'box-shadow 0.3s ease', '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}>
                <Grid container spacing={1} justifyContent={"space-between"} alignItems={"center"}>

                  <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TabTextLabel text={'Items Seleccionado'} mt={0} pb={0} pl={0} pt={0} />
                  </Grid>

                  <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' } }}>
                    <ModalProductoEgresoComponete
                      ubicacion={form.watch('ubicacion')}
                      onChange={(e) => {
                        const aux: MaterialTransferido = {
                          id: e.id_producto,
                          codigo: e.codigo,
                          cantidad: '1',
                          contiene_serie: e.contiene_serie,
                          producto_data: {
                            codigo: e.codigo,
                            categoria_producto: e.categoria_producto,
                            subcategoria_producto: e.subcategoria_producto,
                            descripcion: e.descripcion,
                            stock_actual: e.stock_actual,
                            modelo_producto: e.modelo_producto,
                            marca_producto: e.marca_producto,
                            unidad_medida: e.unidad_medida,
                            usa_metros: e.usa_metros,
                            contiene_serie: e.contiene_serie,
                            metros_base  : e.metros_base
                          },
                          costo_actual: e.costo_actual,
                          costo_compra: e.costo_compra,
                          costo_promedio: e.costo_promedio,
                          series: []
                        }

                        handleAgregarProducto(aux)
                      }}

                    />
                  </Grid>

                  <div className="linea" />

                  <Grid item xs={12}>
                    <SampleTablePagination
                      columns={columnsSolicitudEgreso}
                      data={paginatedData}
                      rowCount={productos.length}
                      setPagination={setPagination}
                      pagination={pagination}
                      rowNumber={true}
                    />
                  </Grid>

                </Grid>
              </Paper>

            </Grid>

          </Grid>
        </>
      </SingleTableBoxScene >
    </>
  )

}
